const parseBool = (value) => {
  if (!value) return false;
  const normalized = String(value).trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
};

const debugLogsEnabled = () => parseBool(process.env.REACT_APP_DEBUG_LOGS);

export const logError = (...args) => {
  if (debugLogsEnabled()) console.error(...args);
};

export const logWarn = (...args) => {
  if (debugLogsEnabled()) console.warn(...args);
};

export const logInfo = (...args) => {
  if (debugLogsEnabled()) console.info(...args);
};
